<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12.0001" r="6.94006" stroke="currentColor" stroke-width="1.5"/>
        <path d="M9 12H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M12.0001 9L12.0001 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
</template>
